import React from 'react'

const PageTitle = ({blockTitle}) => {
  return (
    <>
     <p className='title'>
        {blockTitle}
     </p>
    </>
  )
}

export default PageTitle